import i18n from '@app/plugins/i18n';
import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { TimeConditionService } from '@pbx/services/TimeConditionService';
import CreateTimeInterval from '@pbx/components/time-conditions/modals/create-time-interval';

class TimeConditionModalService extends ModalService {
  constructor() {
    super(TimeConditionService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('pbx.time-condition.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }

  create_time_interval() {
    return this.$open({
      title: i18n.t('pbx.group.form.field.work_time'),
      width: this.size.default,
      render: h =>
        h(CreateTimeInterval, {
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new TimeConditionModalService();
export { instance as TimeConditionModalService };
